import { cn } from '@/lib/utils'
import { sortHeaders } from '@/lib/csv-upload/utils/column-utils'
import { IntegrationSource } from '@super/shared-types'

interface CSVColumnHeadersProps {
  headers: string[]
  pmsType: IntegrationSource | ''
  uploadType: 'contacts' | 'properties' | 'units'
}

export function CSVColumnHeaders({
  headers,
  pmsType,
  uploadType,
}: CSVColumnHeadersProps) {
  if (headers.length === 0) {
    return null
  }

  const sortedHeaders = sortHeaders(headers, pmsType || 'appfolio', uploadType)

  return (
    <div>
      <h4 className="text-sm font-medium mb-2">Detected columns:</h4>
      <div className="flex gap-2 overflow-x-auto pb-2">
        {sortedHeaders.map(({ name, isRequired }, index) => (
          <span
            key={index}
            className={cn(
              'px-2 py-1 text-xs rounded whitespace-nowrap flex-shrink-0',
              isRequired
                ? 'bg-success-muted text-success border border-success-border'
                : 'bg-muted text-muted-foreground',
            )}
          >
            {name}
          </span>
        ))}
      </div>
    </div>
  )
}
